<template>
  <div
    ref="form"
    class="form"
  >
    <div class="bscroll-container">
      <div :immediate-validate="false">
        <format-history
          v-if="permissionInfo && permissionInfo.is_show_compare"
          :form-history-id="formHistoryId"
        />
        <div
          v-for="(modules, k) in formData"
          :id="`anchor_${modules.fieldkey}`"
          :key="k"
          :class="{ 'hide': hideModule(k) }"
        >
          <div
            v-show="modules.show"
            class="module"
          >
            <!-- 如果接待方式启用，则隐藏来源的标题 -->
            <h2
              class="title"
              :class="{
                hide: (k === 'from_info' || k === 'info_detail') && receptionInfoChild.length
              }"
            >
              <span
                v-if="k === 'reception_info'"
                class="title-name"
              >
                {{ formData['from_info'] && formData['from_info'].fieldname || formData['info_detail'] && formData['info_detail'].fieldname }}
              </span>
              <span
                v-else
                class="title-name"
              >
                {{ modules.fieldname }}
              </span>
              <span
                v-if="modules && modules.child && modules.child.length"
                class="operate"
                @click="handleSpread(modules,k)"
              >
                <span
                  v-if="modules.spread"
                  class="text"
                >
                  {{ $t('message["1106"]') }}
                </span>
                <span
                  v-else
                  class="text"
                >
                  {{ $t('message["1564"]') }}
                </span>

                <i
                  v-if="modules.spread"
                  class="iconfont iconicon-test14"
                />
                <i
                  v-else
                  class="iconfont iconicon-test17"
                />
              </span>
            </h2>
            <p
              v-if="k === 'base_info' && recycleRuleTips"
              class="recycle-rule-tips"
            >
              {{ recycleRuleTips }}
            </p>
            <div
              v-show="modules.spread"
              class="module-content"
            >
              <!-- 回访信息 -->
              <template v-if="k === 'return_info'">
                <ReturnVisite v-if="permissionInfo && permissionInfo.is_show_followups" />
              </template>
              <!-- 评论内容 -->
              <template v-else-if="k === 'comment_info'">
                <CommentContent v-if="permissionInfo && permissionInfo.is_show_comments" />
              </template>
              <!-- 审核和详情页面 接待信息 start -->
              <div
                v-else-if="k === 'reception_info' && modules && modules.child && modules.child[0]"
                class="reception-info"
              >
                <my-item
                  v-if="formData['from_info'] && modules"
                  :data="modules.child[0]"
                  class="validator-item"
                />

                <!--  -->
              </div>
              <!-- 接待信息 end -->
              <!-- 来源详情--通过的询盘详情，不可编辑 -->
              <template v-else-if="modules.fieldkey === 'info_detail'">
                <InforFrom />
              </template>
              <!-- 信息来源部分特殊处理(录入/审核询盘) start -->
              <template v-else-if="modules.fieldkey === 'from_info'">
                <!-- 信息来源父级 -->
                <div
                  v-if="!modules.isedit"
                  class="validator-item border-bottom-1px"
                >
                  <label>{{ modules.fieldname }}</label>
                  <div class="fieldValue">
                    <not-can-edit :data="fromNotEditItem" />
                  </div>
                </div>
                <my-item
                  v-if="modules.isedit && currentFrom"
                  :value="currentFrom"
                  :data="modules"
                  @change="handleChangeFromSource"
                />
                <!-- 来源详情 child -->
                <template v-if="currentFrom">
                  <my-item
                    v-for="(item) in modules.childObj && modules.childObj[currentFrom] && modules.childObj[currentFrom].child"
                    :ref="`item_${getId()}`"
                    :key="item.fieldkey"
                    class="clearfix"
                    :data="item"
                    :modules-data="modules"
                    :current-from="currentFrom"
                    @delete="handleDeleteItem"
                  />
                </template>
              </template>
              <!-- 信息来源部分特殊处理 end -->

              <!-- 人员信息 -->
              <template v-else-if="modules.fieldkey === 'info'">
                <member-edit
                  ref="memberInfo"
                  :data="modules"
                  @change="handleChangeMember"
                />
              </template>

              <!-- 表单循环的主题部分 start -->
              <template v-else>
                <my-item
                  v-for="(item) in modules.child"
                  v-show="item.fieldtype ? true : false"
                  :ref="`item_${getId()}`"
                  :key="item.fieldkey"
                  class="clearfix"
                  :data="item"
                  :modules-data="modules"
                  @change="handleChangeItem($event, item)"
                  @delete="handleDeleteItem"
                />
              </template>
              <!-- 表单循环的主题部分 end -->
            </div>
          </div>
        </div>

        <cube-form-group
          v-if="permissionInfo"
          ref="footer"
          class="footer form-btn-box"
        >
          <!-- 新增评论 -->
          <cube-button
            v-if="permissionInfo.is_add_comments"
            class="cube-btn-light"
            @click="handleAddCommentModal"
          >
            {{ $t('message["1351"]') }}
          </cube-button>
          <!-- 新增回访 -->
          <cube-button
            v-if="permissionInfo.is_add_followups"
            class="cube-btn-light"
            @click="handleSetRemind"
          >
            {{ $t('message["1692"]') }}
          </cube-button>
          <!-- 拒审 -->
          <cube-button
            v-if="permissionInfo.is_show_reject"
            class="cancel-btn cube-btn-light"
            @click="confirmReject(saveType = 'reject')"
          >
            {{ $t('message["542"]') }}
          </cube-button>
          <!-- 状态是 待审核，按钮显示 通过，拒审 -->
          <cube-button
            v-if="permissionInfo.is_show_approval"
            class="confirm-btn cube-btn-primary"
            @click="submitHandler(saveType = 'pass')"
          >
            {{ $t('message["1206"]') }}
          </cube-button>
          <!-- 状态是 已拒审，按钮显示 重新通过 -->
          <cube-button
            v-if="permissionInfo.is_show_reapproval"
            class="confirm-btn cube-btn-primary"
            @click="submitHandler(saveType = 'pass')"
          >
            {{ $t('message["1624"]') }}
          </cube-button>
          <!-- 状态是已通过，且通过信息列表和查重进入详情页，按钮显示 保存 -->
          <cube-button
            v-if="permissionInfo.is_show_save"
            class="confirm-btn cube-btn-primary"
            @click="submitHandler(saveType = 'save')"
          >
            {{ $t('message["21"]') }}
          </cube-button>
        </cube-form-group>
      </div>
    </div>
    <!-- 拒审弹窗 -->
    <reject-modal
      :visible.sync="showRejectModal"
      :inquiry-id="inquiryId"
      :audit-roleid="groupRoleid"
      :audit-groupid="groupGroupid"
    />
    <!-- 查重弹窗 -->
    <repeat-modal
      :visible.sync="showRepeatModal"
      :data="repeatData"
      :save-type="saveType"
      :again-save-form="againSaveForm"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { inquiryEdit, inquiryApproval } from '@/services/inqueryServices'
import inquiryFormMixin from '@/lib/inquiryFormMixin'
import MyItem from './../create/Item'
import CommentContent from './CommentContent'
import NotCanEdit from '@/components/mobile/formItem/NotCanEdit'
import MemberEdit from './../create/MemberEdit'
import RejectModal from './modal/RejectModal'
import RepeatModal from './../detail/modal/RepeatModal'
import eventBus from '@/lib/eventBus'
import ReturnVisite from './ReturnVisite'
import InforFrom from './InforFrom'
// import AddCommentModal from './modal/AddCommit'
// import AddReturnVisitModal from './modal/AddFollowupModal'
import FormatHistory from './../create/FormatHistory'
import { cloneDeep } from 'lodash'
let uniqueid = 1
const FROM_SOPURCE = 'notice'

export default {
  components: {
    MyItem,
    NotCanEdit,
    MemberEdit,
    RejectModal,
    RepeatModal,
    ReturnVisite,
    CommentContent,
    InforFrom,
    // AddCommentModal,
    // AddReturnVisitModal,
    FormatHistory
  },
  mixins: [inquiryFormMixin],
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    flag: {
      type: String,
      default: ''
    }
  },
  data () {
    // TODO: this.data里面多出个undefined的key，需要排查处理
    delete this.data.undefined
    return {
      currentFrom: '',
      returnVisible: true,
      commentVisible: true,
      formData: cloneDeep(this.data),
      // showAddCommentModal: false,
      // showSetRemindModal: false,
      // 拒审数据
      showRejectModal: false,
      groupRoleid: 0,
      groupGroupid: 0,

      // 查重数据
      showRepeatModal: false,
      repeatData: [],

      // 编辑时保存的类型
      saveType: '',

      // 配置里删除的项在编辑里删除
      delfields: [],

      // 编辑保存禁止重复提交
      confirmLoading: false,

      validity: {},
      valid: undefined,

      options: {
        scrollToInvalidField: false,
        layout: 'standard' // classic fresh standard
      },
      errorElements: []
    }
  },
  computed: {
    ...mapState('inquery/detailData', ['joinTeamCascaderShow', 'followup']),
    ...mapState('inquery/relateData', ['recycleRuleTips']),
    ...mapGetters('inquery/detailData', ['memberInfo', 'permissionInfo']),

    from () { // all, my, audit, checkrepeat
      return this.$route.query.from
    },
    type () {
      return this.$route.query.type
    },
    inquiryId () {
      return this.$route.params.inquiryId
    },
    hideContent () {
      if (this.from === 'audit' || !this.permissionInfo) return false

      return !this.permissionInfo.is_show_inquirydetail && !this.permissionInfo.is_show_fromdetail && !this.permissionInfo.is_show_followups && !this.permissionInfo.is_show_comments && !this.permissionInfo.is_show_historys
    },
    baseInfo () {
      const { base_info: baseInfo = {} } = this.data || {}
      return baseInfo
    },
    /* isneeded () {
      let b = false
      let { baseInfo } = this
      baseInfo.child && baseInfo.child.forEach(item => {
        if (item.fieldkey === 'info_type') {
          b = !!item.isneeded
        }
      })
      return b
    }, */
    receptionInfoChild () {
      if (!this.formData) return
      let receptionInfo = this.formData['reception_info'] || {}
      return receptionInfo.child || []
    },
    fromInfoChild () {
      const { from_info: fromInfo = {} } = this.formData || {}
      const { child = [] } = fromInfo
      return child
    },
    fromNotEditItem () {
      let { fieldvalue, childObj = {} } = this.formData.from_info || {}
      let obj = {}
      if (fieldvalue && childObj[fieldvalue]) {
        obj.fieldvalue = childObj[fieldvalue].fieldname
      }
      obj.fieldname = this.formData.from_info.fromname
      obj.fieldtype = 'string'
      return obj
    },
    auditStatus () {
      const { audit_status: auditStatus } = this.memberInfo || {}
      return auditStatus
    },
    showPassTab () {
      let flag = false
      if (this.from === 'audit') {
        flag = false
      } else {
        if (this.auditStatus === 0 || this.auditStatus === -1) {
          flag = false
        } else if (this.auditStatus === 1) {
          flag = true
        }
      }
      return flag
    },
    checkrepeatfieldkey () {
      return this.$route.query.checkrepeatfieldkey
    },
    formHistoryId () {
      const { form_history_id: formHistoryId } = this.memberInfo
      return formHistoryId
    }
  },
  watch: {
    baseInfo: {
      handler (val) {
        if (val) {
          if (!val || !val.child) return
          // 成交默认状态
          for (let item of val.child) {
            if (item.fieldkey === 'info_status') {
              this.setDealShow(item)
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  async mounted () {
    // 设置来源的默认值和默认请求关联接口
    this.initFromInfo()

    // 所属团队以第一条数据为默认值，或匹配到关联人员，更新 info 的 child 数据
    eventBus.$on('getMemberInfo', (newData) => {
      this.formData.info = Object.assign({}, this.formData.info, newData)
    })
    // 获取询盘规则重置后的提示说明
    this.fetchRecycleLogTip({
      inquiryid: this.inquiryId
    })
  },
  methods: {
    ...mapActions('inquery/detailData', ['deleteDetail']),
    ...mapActions('inquery/relateData', ['fetchRecycleLogTip']),

    hideModule (k) {
      let { isDeal, isInvalid, isDiscard } = this
      return (k === 'deal_info' && !isDeal) || (k === 'invalid_info' && !isInvalid) || (k === 'discard_info' && !isDiscard)
    },
    getId () {
      return uniqueid++
    },
    handleAddCommentModal () {
      // this.showAddCommentModal = true
      eventBus.$emit('openCommentModal')
    },
    handleSetRemind () {
      // this.showSetRemindModal = true
      // eventBus.$emit('openAddReturnVisitModal')
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: 'addFollowup'
        }
      })
    },
    handleSpread (modules, k) {
      let data = JSON.parse(JSON.stringify(this.formData))
      let json = JSON.parse(JSON.stringify(modules))
      if (json.spread) {
        json.spread = false
      } else {
        json.spread = true
      }

      data[k] = json
      this.formData = data

      if (k === 'reception_info' && this.formData['info_detail']) {
        this.formData['info_detail'].spread = json.spread
      } else if (k === 'reception_info' && this.formData['from_info']) {
        this.formData['from_info'].spread = json.spread
      }
    },
    /**
     * 更新数据
     */
    /* onChangeItem (item) {
      this.setDealShow(item)
    }, */
    /**
     * 切换成交显示隐藏
     */
    setDealShow (item) {
      if (item.fieldkey === 'info_status') {
        const dealStatusItem = item.options.find(option => option.name === this.$t('message["109"]')) || {}
        const res = dealStatusItem.id === item.fieldvalue
        if (res) {
          this.formData.deal_info.show = true
        } else {
          this.formData.deal_info.show = false
        }
      }
      this.$forceUpdate()
    },

    /**
     * 切换信息来源：网站，电话，邮箱等
     */
    handleChangeFromSource (data) {
      if (!this.formData || !this.formData.from_info) return

      for (let item of this.fromInfoChild) {
        if (item.id === data.fieldvalue) {
          this.formData.from_info.fieldvalue = item.id
          this.currentFrom = item.id
        }
      }
      this.relateTeamInfo(this.formData.from_info)
    },

    scrollIntoView () {
      let $scrollElement
      if (this.errorElements[0] && this.errorElements[0].previousSibling) {
        $scrollElement = this.errorElements[0].previousSibling
      } else if (this.errorElements[0]) {
        $scrollElement = this.errorElements[0]
      }
      $scrollElement && $scrollElement.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    },

    async submitHandler (saveType) {
      let hasError = await this.validateResult()

      // 滚动到错误的第一个地方
      this.scrollIntoView()

      // 审核详情判断所属团队小组必填
      let error = false
      if (this.from === 'audit' || this.auditStatus === 0 || this.auditStatus === -1) {
        error = this.getGroupMember()
      }
      if (!hasError && !error) {
        if (this.confirmLoading) return

        this.confirmLoading = true

        this.handleSubmit(saveType)
      }
    },

    /**
     * 点击拒审, 通过，保存时，获取拒审人员/录入人员（所属团队/组）的 id
     */
    getGroupMember () {
      let { info = {} } = this.formData || {}
      let { child = [] } = info
      for (let item of child) {
        const { fieldkey, info: itemInfo = {} } = item
        if (fieldkey === 'group') {
          // const $memberInfo = this.$refs.memberInfo && this.$refs.memberInfo[0]
          // const joinTeamCascaderInfo = $memberInfo.joinTeamCascaderInfo
          // this.groupRoleid = itemInfo.roleid || joinTeamCascaderInfo.roleid || 0
          // this.groupGroupid = itemInfo.groupid || joinTeamCascaderInfo.groupid || 0
          this.groupRoleid = itemInfo.roleid || 0
          this.groupGroupid = itemInfo.groupid || 0
        }
      }

      if (!this.joinTeamCascaderShow || (this.groupRoleid && this.groupGroupid)) {
        return false
      } else {
        this.$selefToast({ type: 'error', text: this.$t('message["881"]') })
        return true
      }
    },

    /**
     * 拒审提交接口
     */
    async confirmReject (saveType) {
      let error = this.getGroupMember()
      if (!error) {
        // 审核只需要校验所属团队，不需要校验查重和其他
        this.showRejectModal = true
      }
    },

    againSaveForm ({ saveType, checkrepeatconfirm }) {
      this.handleSubmit(saveType, checkrepeatconfirm)
    },
    /**
     * 点击保存，通过，再次通过，拒审等按钮
     * saveType：类型：save，pass，reject
     * checkrepeatconfirm: 1是点击了查重弹窗的继续保存
     */
    async handleSubmit (saveType, checkrepeatconfirm) {
      this.$bus.$emit('myQuillEditorBlur')
      const formData = await this.setFormDataParams(this.formData)
      let params = {
        inquiryid: this.inquiryId,
        ...formData,
        delfields: this.delfields
      }
      if (checkrepeatconfirm === 1) {
        params.checkrepeatconfirm = checkrepeatconfirm
      }
      await this.comfirmForm(saveType, params)
    },

    /**
     * params: 处理过的表单数据作为保存参数
     */
    async comfirmForm (saveType, params) {
      let chain
      let _this = this
      // 查重详情额外加参数
      if (this.from === 'checkrepeat' && this.checkrepeatfieldkey) {
        params.scope = this.from
        params.checkrepeatfieldkey = this.checkrepeatfieldkey
      }
      if (saveType === 'save') { // 点击保存按钮
        chain = await inquiryEdit()
        chain
          .onSuccess(() => {
            // 如果回收提示有值，返回列表
            if (this.recycleRuleTips) {
              let timer = null
              clearTimeout(timer)
              timer = setTimeout(() => {
                this.$router.push({
                  name: 'InqueryList',
                  query: {
                    type: this.type,
                    from: this.from
                  }
                })
              }, 2000)
            } else { // 保存成功刷新询盘详情页面
              // eventBus.$emit('fetchInquiryDetail')
              location.reload()
            }
          })
          .onNetSuccess(raw => {
            this.confirmLoading = false
            const { data } = raw
            if (data.error === 104) { // 有重复
              this.showRepeatModal = true
              this.repeatData = data.payload
            }
          })
          .config({
            error104: false,
            error100 (raw) {
              if (raw.message) {
                _this.$selefToast({ type: 'error', text: raw.message })
              } else if (raw.payload && raw.payload.length) {
                _this.$selefToast({ type: 'error', text: raw.payload[0] })
              }
            }
          })
          .params(params).fetch()
      } else if (saveType === 'pass') { // 点击通过/重新通过按钮
        chain = await inquiryApproval()
        chain
          .onSuccess(() => { // 保存成功跳转到待审核列表
            if (this.from === FROM_SOPURCE) {
              this.$router.push({ name: 'recordNotice' })
            } else {
              this.$router.push({
                name: 'InqueryAudit',
                query: {
                  type: 'wait-audit',
                  from: 'audit'
                }
              })
            }
          })
          .onNetSuccess(raw => {
            this.confirmLoading = false
            const { data } = raw
            if (data.error === 104) { // 有重复
              this.showRepeatModal = true
              this.repeatData = data.payload
            }
          })
          .config({
            error104: false,
            error100 (raw) {
              // TODO: 处理后端错误
              if (raw.message) {
                _this.$selefToast({ type: 'error', text: raw.message })
              } else if (raw.payload && raw.payload.length) {
                _this.$selefToast({ type: 'error', text: raw.payload[0] })
              }
            }
          })
          .params(params).fetch()
      }
      /* else if (saveType === 'reject') {
        this.showRejectModal = true
      } */
      // 保存前要判断查重，有重复弹窗展示
    },

    /**
     * 删除询盘
     */
    async handleDelete () {
      this.$createDialog({
        type: 'confirm',
        icon: 'cubeic-alert',
        title: this.$t('message["493"]'),
        content: this.$t('message["969"]') + '？',
        confirmBtn: {
          text: this.$t('message["915"]'),
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: this.$t('message["896"]'),
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: async () => {
          const chain = await this.deleteDetail()
          chain
            .onSuccess((raw, res) => {
              if (!res.error) {
                let name = ''
                let { type = '', from = ' ' } = this
                if (this.from === 'audit') {
                  name = 'InqueryAudit'
                } else if (this.from === 'checkrepeat') {
                  name = 'InqueryRepeat'
                } else {
                  name = 'InqueryList'
                }
                if (this.from === FROM_SOPURCE) {
                  this.$router.push({ name: 'recordNotice' })
                } else {
                  this.$router.push({
                    name,
                    query: {
                      type,
                      from
                    }
                  })
                }
              }
            })
            .params({
              inquiryid: this.inquiryId
            })
            .fetch()
        },
        onCancel: () => {
          this.$createToast({
            type: 'warn',
            time: 1000,
            txt: this.$t('message["896"]')
          }).show()
        }
      }).show()
    },
    /**
     * 删除配置里更改的表单项
     */
    handleDeleteItem (modulesData, fieldkey) {
      if (modulesData && modulesData.fieldkey === 'from_info' && modulesData.childObj && modulesData.childObj[this.currentFrom]) {
        let childData = modulesData.childObj[this.currentFrom].child

        childData.forEach((item, i) => {
          if (fieldkey === item.fieldkey) {
            childData.splice(i, 1)
            this.delfields.push(fieldkey)
          }
        })

        this.formData.from_info.childObj[this.currentFrom].child = childData
      } else {
        if (!modulesData.child) return

        modulesData.child.forEach((item, i) => {
          if (fieldkey === item.fieldkey) {
            modulesData.child.splice(i, 1)
            this.delfields.push(fieldkey)
          }
        })
        this.$forceUpdate()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hide {
  display: none;
}
.form {
  position: relative;
  padding: 0 0 90px;
  h2.title {
    line-height: 24px;
    padding: 12px 12px 6px;
    font-size: 14px;
    // font-weight: bold;
    color: #999;
    background-color: #f5f5f5;
  }
  h2 {
    .operate {
      .text {
        color: #5077aa;
      }
      i {
        color: #5077aa;
      }
      float: right;
    }
  }

  .reception-info {
    background-color: #fff;
    .item {
      display: flex;
      min-height: 56px;
      line-height: 56px;
      padding: 0 12px;
      border-bottom: solid 1px #ebebeb;
      label {
        width: 100px;
        min-height: 32px;
        line-height: 32px;
        padding: 12px 26px 12px 0;
        color: #888;
        word-break: break-all;
      }
      .fieldValue {
        flex: 1;
        width: 200px;
      }
    }
  }
  .recycle-rule-tips {
    padding: 8px 12px;
    font-size: 12px;
    line-height: 24px;
    color: #FFC06A;
    background-color: #FFF9EC;
    border: solid 1px #F6A953;
    border-left: none;
    border-right: none;
  }
  .footer {
    z-index: 99;
    display: flex;
    justify-content: space-between;
    height: auto;
    padding: 8px;
    background-color: #fff;
    ::v-deep .cube-form-group-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .cube-btn {
      flex: 1;
      margin: 0 6px;
      // width: 358px;
      height: 46px;
      line-height: 46px;
      padding: 0 !important;
    }
  }
}
</style>
